import React, { useState, useEffect } from 'react';
import { Container, Table, Button } from 'react-bootstrap';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AllJobs = () => {
  const [jobs, setJobs] = useState([]);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { currentUser, logout } = useAuth();

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get('http://localhost:5001/api/jobs', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setJobs(response.data);
      } catch (error) {
        setError('Error fetching jobs');
        console.error('Error fetching jobs:', error);
      }
    };

    fetchJobs();
  }, []);

  const handleJobClick = (id) => {
    window.open(`/jobs/${id}`, '_blank'); // Open job details in a new tab
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(`http://localhost:5001/api/jobs/${id}`, { status: newStatus, modifiedDates: [new Date()] }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setJobs((prevJobs) => prevJobs.map((job) => (job._id === id ? { ...job, status: newStatus, modifiedDates: [new Date()] } : job)));
    } catch (error) {
      console.error('Error updating job status:', error);
    }
  };

  const handleDelete = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`http://localhost:5001/api/jobs/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setJobs((prevJobs) => prevJobs.filter((job) => job._id !== id));
    } catch (error) {
      console.error('Error deleting job:', error);
    }
  };

  const handleModify = (id) => {
    navigate(`/jobs/${id}/edit`);
  };

  if (error) {
    return <p>{error}</p>;
  }

  if (jobs.length === 0) {
    return <p>No jobs available</p>;
  }

  return (
    <Container className="my-5">
      <h2>All Jobs</h2>
      {currentUser && (
        <div className="auth-links mb-3">
          <Button onClick={logout}>Logout</Button>
          <Button variant="link" onClick={() => navigate('/admindash')}>Dashboard</Button>
        </div>
      )}
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Title</th>
            <th>Experience</th>
            <th>Location</th>
            <th>Type</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {jobs.map((job) => (
            <tr key={job._id}>
              <td>
                <Button variant="link" onClick={() => handleJobClick(job._id)}>{job.title}</Button>
              </td>
              <td>{job.experience}</td>
              <td>{job.location}</td>
              <td>{job.type}</td>
              <td>{job.status}</td>
              <td>
                <Button variant="primary" onClick={() => handleModify(job._id)}>
                  Modify
                </Button>
                <Button variant="warning" onClick={() => handleStatusChange(job._id, 'closed')}>
                  {job.status === 'closed' ? 'Reopen' : 'Close'}
                </Button>
                <Button variant="secondary" onClick={() => handleStatusChange(job._id, 'published')} disabled={job.status === 'published'}>
                  {job.status === 'published' ? 'Published' : 'Publish'}
                </Button>
                <Button variant="danger" onClick={() => handleStatusChange(job._id, 'archived')}>
                  Archive
                </Button>
                <Button variant="danger" onClick={() => handleDelete(job._id)}>
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default AllJobs;
